import { FormField } from '../../type';
import { prefillValue } from './prefillValue';

interface Args {
  fields: FormField[];
  query?: URLSearchParams;
}

/** Only params named after a field of this form are taken from the url. */
export const prefillValues = ({
  fields,
  query,
}: Args): Record<string, unknown> => {
  if (!query) return {};

  const entries = fields.flatMap((field): [string, unknown][] => {
    const { name } = field;
    if (!name) return [];

    const raw = query.get(name);
    if (raw === null) return [];

    const value = prefillValue({ field, raw });
    return value === undefined ? [] : [[name, value]];
  });

  return Object.fromEntries(entries);
};
